import {
  breakpointsVuetifyV3,
  useBreakpoints as breakpoints,
} from "@vueuse/core";

export const useBreakpoints = () => breakpoints(breakpointsVuetifyV3);
